import { render, staticRenderFns } from "./WorkButtons.vue?vue&type=template&id=3f84d580&scoped=true&"
import script from "./WorkButtons.vue?vue&type=script&lang=js&"
export * from "./WorkButtons.vue?vue&type=script&lang=js&"
import style0 from "./WorkButtons.vue?vue&type=style&index=0&id=3f84d580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f84d580",
  null
  
)

export default component.exports